import React, { useEffect, useRef, useState } from "react";
import { LOCATION_COLORS as LOC_ACCENT } from "./chartTheme";

// FOX design tokens
const FOX_BLUE = "#378ADD";
/* NSA purple, PFC blue, BGFC orange -- from chartTheme, not written out
   again here. The local copy this replaces is the reason two pages drifted:
   one drew BGFC teal and PFC red, another a different orange, purple and
   blue from everyone else. Reading the shared map also means these follow
   the light/dark toggle, which a literal cannot. */

// pct: 0-100 for counted mode. Pass null/undefined for animated (indeterminate) mode.
// active: whether loading is in progress. When it flips false, bar snaps to 100 then fades.
// accent: optional location code ("NSA"|"BGFC"|"PFC") to tint the bar; defaults to FOX blue.
export default function LoadingBar({ active, pct = null, accent = null }) {
  const color = (accent && LOC_ACCENT[accent]) || FOX_BLUE;
  const animated = pct === null;

  const [fakePct, setFakePct] = useState(0);
  const [visible, setVisible] = useState(false);
  const timer = useRef(null);

  // Animated mode: creep toward 90% while active.
  useEffect(() => {
    if (!animated) return;
    if (active) {
      setVisible(true);
      setFakePct(8);
      timer.current = setInterval(() => {
        setFakePct((p) => (p >= 90 ? 90 : p + Math.max(1, (90 - p) * 0.08)));
      }, 200);
    } else {
      if (timer.current) clearInterval(timer.current);
      setFakePct(100);
      const t = setTimeout(() => setVisible(false), 400);
      return () => clearTimeout(t);
    }
    return () => timer.current && clearInterval(timer.current);
  }, [active, animated]);

  // Counted mode: show while active or until it reaches 100, then fade.
  useEffect(() => {
    if (animated) return;
    if (active || pct < 100) {
      setVisible(true);
    } else {
      const t = setTimeout(() => setVisible(false), 400);
      return () => clearTimeout(t);
    }
  }, [active, pct, animated]);

  const shownPct = animated ? fakePct : pct;
  if (!visible && !active) return null;

  return (
    <div
      className="fox-loading-bar-track"
      role="progressbar"
      aria-valuenow={Math.round(shownPct)}
      aria-valuemin={0}
      aria-valuemax={100}
      style={{ opacity: visible ? 1 : 0 }}
    >
      <div
        className="fox-loading-bar-fill"
        style={{ width: `${shownPct}%`, background: color }}
      />
    </div>
  );
}
